export default "__VITE_ASSET__CmIQWU1L__"